import React from 'react';
import SectionTitle from '../sectionTitle/SectionTitle';

const NewsLetterOne = () => {
  return (
    <div className="edu-newsletter-area newsletter-style-1 datatalent-section-gap bg-color-primary">
      <div className="container eduvibe-animated-shape">
        <div className="row">
          <div className="col-lg-12">
            <div className="inner text-center">
              <SectionTitle
                classes = "text-white text-center"
                slogan = "Subscribe Newsletter"
                title = "Get Every Latest News"
              />
              {/* <div className="newsletter-form newsletter-form-style-1 mt--60">
                <form
                  action="https://formspree.io/f/xlekeqld"
                  method="POST"
                  className="input-box">
                  <input type="text" name="source" readOnly value="m2m tech connect newsletter subscription" className="d-none" />
                  <input type="email" name="email" placeholder="Enter your mail address" />
                  <div className="mail-icon">
                    <i className="icon-mail-open-line"></i>
                  </div>
                  <button type="submit" className="send-button"><i className="icon-send-plane-fill"></i></button>
                </form>
              </div> */}
  
              <div id="mc_embed_shell" className="newsletter-form newsletter-form-style-1 mt--60">
                <div id="mc_embed_signup">
                  <form action="https://m2mtechconnect.us4.list-manage.com/subscribe/post?u=e5c23504a89d478fb8efcda11&amp;id=6b54fe4b80&amp;f_id=00706eeaf0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="input-box validate" target="_self" noValidate="">
                    <div id="mc_embed_signup_scroll">
                      {/* <h2>Subscribe</h2> */}
                      {/* <div class="indicates-required">
                        <span class="asterisk">*</span> indicates required
                      </div> */}
                      <div className="mc-field-group">
                        {/* <label for="mce-EMAIL">Email Address <span class="asterisk">*</span></label> */}
                        <input type="email" name="EMAIL" placeholder="Enter your mail address" id="mce-EMAIL" />
                        <div className="mail-icon">
                          <i className="icon-mail-open-line"></i>
                        </div>
                      </div>
                      <div id="mce-responses">
                        <div id="mce-error-response" className="d-none response"></div>
                        <div id="mce-success-response" className="d-none response"></div>
                      </div>
                      <div aria-hidden="true" style={{position: "absolute", left: "-5000px"}}>
                        <input type="text" name="b_e5c23504a89d478fb8efcda11_6b54fe4b80" tabIndex="-1" defaultValue="" />
                      </div>
                      <div>
                        <button type="submit" id="mc-embedded-subscribe" className="send-button"><i className="icon-send-plane-fill"></i></button>
                        {/* <input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button" value="Subscribe" /> */}
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
          <div className="shape-image shape-image-1">
            <img src="/images/shapes/shape-03-04.png" alt="Shape Thumb" />
          </div>
          <div className="shape-image shape-image-2">
            <img src="/images/shapes/shape-16.png" alt="Shape Thumb" />
          </div>
          <div className="shape-image shape-image-3">
            <img src="/images/shapes/shape-13-02.png" alt="Shape Thumb" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsLetterOne;